// @flow
import React from 'react';
import PropTypes from 'prop-types';
import InfiniteScroll from 'react-infinite-scroll-component';
import Tile from './tile/TileComponent';

import './TileList.scss';
import SkeletonTiles from '../../common/skeleton-tiles/SkeletonTilesComponent';

export type Props = {
  items: Array<Object>,
  loadMore: Function,
  hasMore: boolean,
  isLoading: boolean,
  hoverButtonText: string,
};

type Context = {
  intl: Object,
};

const getTiles = (context, items, hoverButtonText) =>
  items.map(({ name, title, shortDescription, price, images, itemUrl, isCustomisable }) => {
    return (
      <Tile
        className="mbs_tile-list__tile"
        key={name}
        title={title}
        description={shortDescription}
        price={price.original}
        discountedPrice={price.discounted}
        imageUrl={images.thumb}
        hoverButtonText={hoverButtonText}
        itemUrl={itemUrl}
        isCustomisable={isCustomisable}
      />
    );
  });

const TileList = (props: Props, context: Context) => {
  const { items, loadMore, hasMore, isLoading, hoverButtonText } = props;
  const tiles = getTiles(context, items, hoverButtonText);

  return (
    <InfiniteScroll
      dataLength={tiles.length}
      className="layout layout--row-spacing-responsive u-marginLeft-0 accessories-tile-list"
      next={loadMore}
      hasMore={hasMore}
    >
      {tiles}
      {isLoading && <SkeletonTiles amount={6} square minimal />}
    </InfiniteScroll>
  );
};

TileList.contextTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }),
};

TileList.propTypes = {
  items: PropTypes.array.isRequired,
  loadMore: PropTypes.func.isRequired,
  hasMore: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  hoverButtonText: PropTypes.string.isRequired,
};

export default TileList;
